/* ==========================================================================
   INTERACTIVE CONSULTATION INQUIRY MODAL MODULE
   ========================================================================== */

export function initConsultationModal() {
  const modalOverlay = document.getElementById('consultation-modal');
  const modalClose = document.getElementById('modal-close-btn');
  const modalForm = document.getElementById('modal-inquiry-form');
  const successMsg = document.getElementById('modal-success-msg');
  const triggerBtns = document.querySelectorAll('a[href="#contact"], button[data-modal-trigger]');

  if (!modalOverlay) return;

  function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  triggerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      // If it's a contact button, open modal instead of raw anchor jump
      e.preventDefault();
      openModal();
    });
  });

  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
      closeModal();
    }
  });

  // Handle Form Submission
  if (modalForm) {
    modalForm.addEventListener('submit', (e) => {
      e.preventDefault();

      // Show success state
      modalForm.style.display = 'none';
      if (successMsg) {
        successMsg.style.display = 'block';
      }

      // Reset after 4 seconds and close
      setTimeout(() => {
        modalForm.reset();
        modalForm.style.display = 'block';
        if (successMsg) successMsg.style.display = 'none';
        closeModal();
      }, 3500);
    });
  }
}
